interface AddressData {
  streetNumber?: string | null
  streetName?: string | null
  zipcode?: string | null
  city?: string | null
  inseeCode?: string | null
  label?: string | null
}

export const meterSearchAddress = (searchAddress: object, currentAddress: AddressData): AddressData | null => {
  if (Object.keys(searchAddress).length > 0) return null
  const { streetNumber, streetName, zipcode, city, inseeCode, label } = currentAddress
  if (!zipcode || !city || !inseeCode) return null

  return {
    streetNumber: streetNumber ?? '',
    streetName: streetName ?? '',
    zipcode,
    city,
    inseeCode,
    label: label ?? '',
  }
}
